import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-3">分类浏览</h2>
          <p className="text-sm text-foreground-500">探索你喜欢的漫画类型</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map(cat => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}